import * as React from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { setUserInfo } from '../Login/redux-objects/actions';
import {
  AuthContext,
  withAdalLoginApi
} from '../../services/config/AdalConfig';
import LoginAAD from './LoginAAD';
import { UserInfo } from '../Login/common/defaults';

interface ILoginAadControllerPropsFromState {
  serviceURL: string;
  loggingOut: boolean;
  signedOut: boolean;
  currentUser: UserInfo;
}

interface ILoginAadControllerPropsFromActions {
  setUserInfo: (user?: UserInfo) => void;
}

type LoginAadPropType = ILoginAadControllerPropsFromActions &
  ILoginAadControllerPropsFromState;

const ProtectedLoginAAD = withAdalLoginApi(LoginAAD);

class LoginAadController extends React.Component<LoginAadPropType> {
  logOut = () => {
    sessionStorage.setItem('isUsingAAD', 'false');
    sessionStorage.setItem('signedOut', 'true');
    AuthContext.logOut();
  };

  public render() {
    if (
      this.props.loggingOut &&
      sessionStorage.getItem('isUsingAAD') === 'true'
    ) {
      this.logOut();
    }
    return (
      <ProtectedLoginAAD
        setUserInfo={this.props.setUserInfo}
        serviceURL={this.props.serviceURL}
        currentUser={this.props.currentUser}
      />
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    errorMessage: reduxState.Login.errorMessage,
    loggingOut: reduxState.Application.loggingOut,
    serviceURL: reduxState.Application.backendURL,
    signedOut: reduxState.Application.signedOut,
    currentUser: reduxState.Application.currentUser
  };
};

const mapDispatchToProps = {
  setUserInfo
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginAadController);
